var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { VestaEnvironment, VestaSDK, VestaSDKError, } from '@hous3-digital/vesta-sdk';
var VestaConfigurationError = /** @class */ (function (_super) {
    __extends(VestaConfigurationError, _super);
    function VestaConfigurationError() {
        var _this = _super.call(this, 'A configuração da Vesta está indisponível ou inválida. Recarregue e tente novamente.') || this;
        _this.name = 'VestaConfigurationError';
        return _this;
    }
    return VestaConfigurationError;
}(Error));
export { VestaConfigurationError };
var sdk = null;
var sdkConfig = null;
var getInstanceConfig = function () {
    var _a, _b, _c;
    var apiKey = (_a = process.env.VESTA_SDK_API_KEY) === null || _a === void 0 ? void 0 : _a.trim();
    var environment = (_c = (_b = process.env.VESTA_SDK_ENVIRONMENT) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase()) !== null && _c !== void 0 ? _c : 'staging';
    if (!apiKey) {
        throw new VestaConfigurationError();
    }
    if (environment !== VestaEnvironment.STAGING && environment !== VestaEnvironment.PRODUCTION) {
        throw new VestaConfigurationError();
    }
    return {
        apiKey: apiKey,
        environment: environment,
    };
};
var isSameInstanceConfig = function (next) { return Boolean(sdkConfig
    && sdkConfig.apiKey === next.apiKey
    && sdkConfig.environment === next.environment); };
export var getVestaSDK = function () {
    var nextConfig = getInstanceConfig();
    if (!sdk || !isSameInstanceConfig(nextConfig)) {
        sdk = new VestaSDK({
            apiKey: nextConfig.apiKey,
            environment: nextConfig.environment,
        });
        sdkConfig = nextConfig;
    }
    return sdk;
};
export var getVestaValidationConfig = function () {
    var _a;
    var verifierId = (_a = process.env.VESTA_SDK_VERIFIER_ID) === null || _a === void 0 ? void 0 : _a.trim();
    var minKycLevel = 2;
    if (!verifierId) {
        throw new VestaConfigurationError();
    }
    return {
        verifierId: verifierId,
        minKycLevel: minKycLevel,
    };
};
export var isPasskeyCancellation = function (error) {
    if (typeof DOMException !== 'undefined'
        && error instanceof DOMException
        && ['AbortError', 'NotAllowedError'].includes(error.name)) {
        return true;
    }
    if (error instanceof Error) {
        var cause = error.cause;
        return cause ? isPasskeyCancellation(cause) : false;
    }
    return false;
};
export var getVestaErrorMessage = function (error) {
    if (error instanceof VestaConfigurationError) {
        return error.message;
    }
    if (isPasskeyCancellation(error)) {
        return 'Operação com passkey cancelada.';
    }
    if (error instanceof VestaSDKError) {
        switch (error.statusCode) {
            case 0:
                return 'Não foi possível conectar à Vesta. Verifique sua conexão e tente novamente.';
            case 401:
                return 'A chave Vesta é inválida ou incompatível com o ambiente selecionado.';
            case 409:
                return error.apiMessage || 'A credencial não pode ser utilizada neste momento.';
            case 422:
                return 'A credencial está expirada. Faça uma nova verificação.';
            default:
                return error.apiMessage || 'Não foi possível validar a credencial.';
        }
    }
    return error instanceof Error ? error.message : 'Erro desconhecido ao acessar a Vesta.';
};
